export function noBias(arb) {
    return arb.noBias();
}
